export default "__VITE_ASSET__CYQTFfcd__"